import { useState } from "react";
import * as PR from "../../prime-modules/index";
import { filterCountryName } from "../../utils/reuse";

const RoamingColumn = ({ data }) => {
  const [showCountries, setShowCountries] = useState(false);

  let countryName = [];

  if (Array.isArray(data?.countries) && data.countries.length > 0) {
    countryName = data.countries.map(
      (item) => item?.country?.name || "Unknown"
    );
  } else if (data?.country) {
    countryName = [data.country];
  } else {
    countryName = ["Unknown"];
  }

  const roamingCountries =
    data?.roamingcountries || data?.roamingCountries || [];
  const countriesList = roamingCountries
    .map((item) => item.country.name)
    .sort((a, b) => a.localeCompare(b));

  return (
    <div className= "roaming-enabled">
      {roamingCountries.length === 0 && (
        <span>{filterCountryName(countryName.join(", "))}</span>
      )}
      {roamingCountries.length === 1 && (
        <span>{filterCountryName(countriesList[0])}</span>
      )}

      {roamingCountries.length > 1 && (
        <span>
          {`${roamingCountries.length} Countries`}
          {/* Info icon */}
          <i
            className="pi pi-info-circle ml-2"
            onClick={() => setShowCountries(!showCountries)}
            style={{ cursor: "pointer" }}
            title="Click to view countries"
          />
        </span>
      )}

      {/* Dialog for showing countries list */}
      {showCountries && (
        <PR.Dialog
          header="Roaming Countries"
          visible={showCountries}
          onHide={() => setShowCountries(false)}
          dismissableMask
          className="roaming-countries create-voucher-dailog"
          draggable={false}
        >
          <div style={{ columnCount: "3" }}>
            {countriesList.map((country, index) => (
              <div key={index} className="countries-list">
                <span
                  style={{
                    display: "inline-block",
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "#f73759",
                    marginRight: "5px",
                  }}
                />{" "}
                {filterCountryName(country)}
              </div>
            ))}
          </div>
        </PR.Dialog>
      )}
    </div>
  );
};

export default RoamingColumn;
